import { useEffect, useRef } from 'react';

import { useNavigation } from '@react-navigation/native';

import { isIos } from '@/utils/constants-platform-specific';

/**
 * The circular pager has no native animation, it animates itself.
 * If a reset, popTo or other navigation removes it while another screen is on top (like the pick slip),
 * iOS closes everything at once without animation.
 * This gives the pager a close animation first, then runs the navigation again.
 */
export const usePagerSmoothCloseOnRemoval = () => {
    const navigation = useNavigation();
    const isClosingRef = useRef(false);

    useEffect(() => {
        if (!isIos) {
            return;
        }

        return navigation.addListener('beforeRemove', event => {
            // the pager is on top (its own close), or this is the navigation we run again below
            if (navigation.isFocused() || isClosingRef.current) {
                return;
            }

            event.preventDefault();
            isClosingRef.current = true;
            // only updates the native screen, the pager doesn't render again
            navigation.setOptions({ animation: 'fade' });
            // run it after the new animation reaches the native screen
            setTimeout(() => navigation.dispatch(event.data.action), 0);
        });
    }, [navigation]);
};
